import type { Timestamp } from '@bufbuild/protobuf/wkt'
import { ProcurementPlanAutoResubmitCategory } from '@ebalance/proto/bfftypes/v1/procurement_plan_auto_resubmit_category_pb'
import type { ProcurementPlanAutoResubmitSetting } from '@ebalance/proto/bffuser/v1/plan_auto_resubmit_setting_model_pb'

type AutoResubmitUnit = Pick<
  ProcurementPlanAutoResubmitSetting,
  'areaCode' | 'category'
>

/** 設定の単位 (エリア × 区分。AC-PAR-001) を 1 つの文字列にする */
export function autoResubmitUnitKey(unit: AutoResubmitUnit): string {
  return `${unit.areaCode}:${unit.category}`
}

export function isSameAutoResubmitUnit(
  a: AutoResubmitUnit,
  b: AutoResubmitUnit,
): boolean {
  return a.areaCode === b.areaCode && a.category === b.category
}

/**
 * 保存の応答 `saved` を cache の単位 `current` に当ててよいか。 応答は届く順が保存の順と
 * 限らない (閉じる前の保存の応答が、 開き直して保存した後に届く 等) ので、 cache の方が
 * 新しい updatedAt を持つ時は古い応答として捨てる
 */
export function isNotOlderAutoResubmitSetting(
  saved: Pick<ProcurementPlanAutoResubmitSetting, 'updatedAt'>,
  current: Pick<ProcurementPlanAutoResubmitSetting, 'updatedAt'>,
): boolean {
  if (current.updatedAt === undefined) return true
  if (saved.updatedAt === undefined) return false
  return compareTimestamp(saved.updatedAt, current.updatedAt) >= 0
}

function compareTimestamp(a: Timestamp, b: Timestamp): number {
  if (a.seconds !== b.seconds) return a.seconds < b.seconds ? -1 : 1
  return a.nanos - b.nanos
}

/** 区分 → i18n key。 UNSPECIFIED は server が返さない契約 (常に 20 単位) */
export const AUTO_RESUBMIT_CATEGORY_LABEL_KEY: Record<
  ProcurementPlanAutoResubmitCategory,
  string
> = {
  [ProcurementPlanAutoResubmitCategory.UNSPECIFIED]: '',
  [ProcurementPlanAutoResubmitCategory.DEMAND_BG]:
    'page:procurementPlanList.autoResubmitSettings.category.demandBg',
  [ProcurementPlanAutoResubmitCategory.SELF_WHEELING_BG]:
    'page:procurementPlanList.autoResubmitSettings.category.selfWheelingBg',
}
